import {
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ModalComponent } from '@core/modal.component';
import { ProductItem } from '@entities/menu.entity';
import Swiper from 'swiper';
import { ModalService } from '@services/modal.service';
import { CatalogService } from '@models/catalog.service';
import { ProductModalComponent } from '@components/modals/product/item';
import { AppService } from '@services/app.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-product-group-breakfast-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})

export class ProductGroupBreakfastModalComponent extends ModalComponent implements OnInit, OnDestroy  {
  @Input() products: ProductItem[];
  productId: number = null;
  imageLoaded = false;
  isLoaded: boolean[] = [];
  swiper!: Swiper;
  isInitSlider = false;

  // Для отслеживания выбранных элементов для каждого продукта
  selectedItems: any[][] = []; // это массив массивов, где каждый подмассив хранит выбор для конкретного блюда
  selectedItemsValues: any[] = []; // сюда будем хранить значения для каждого блюда

  @ViewChild('slider1') slider1: ElementRef;
  @ViewChild('slider2') slider2: ElementRef;
  @ViewChildren('productTypeItems') productTypeItems: QueryList<ElementRef>;
  private modalService = inject(ModalService);
  private catalogService = inject(CatalogService);
  private appService = inject(AppService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit() {
    // Инициализация состояния для каждого productType и каждого блюда
    this.products.forEach((product: ProductItem, productIndex) => {
      this.selectedItems[productIndex] = []; // Массив для хранения выбранных блюд
      this.selectedItemsValues[productIndex] = {
        weight: '0',
        proteins: '0',
        fats: '0',
        carbo: '0',
        kkal: '0',
      };

      product.comboBreakfastTypes.forEach(type => {
        type.isOpen = false; // Изначально productType свернуты
      });
    });
  }

  toggleProductType(productIndex: number, indexOfType: number) {
    const comboBreakfastType = this.products[productIndex]?.comboBreakfastTypes[indexOfType];

    if (comboBreakfastType.isOpen) {
      comboBreakfastType.isOpen = false;
      this.collapseSection(this.productTypeItems.toArray()[indexOfType]?.nativeElement);
    } else {
      comboBreakfastType.isOpen = true;
      this.expandSection(this.productTypeItems.toArray()[indexOfType]?.nativeElement);
    }
  }

  selectProductItem(productTypeElement: any, productIndex: number, indexOfType: number) {
    // Обновляем выбор только для конкретного productType и конкретного блюда
    this.selectedItems[productIndex][indexOfType] = productTypeElement;

    // Вызываем функцию для расчёта значений для конкретного продукта
    this.calculateSelectedItemsValues(productIndex);
  }

  calculateSelectedItemsValues(productIndex: number) {
    // Инициализируем значения для конкретного блюда
    let totalWeight = 0;
    let totalProteins = 0;
    let totalFats = 0;
    let totalCarbo = 0;
    let totalKkal = 0;

    // Проходим по всем выбранным продуктам для конкретного блюда
    this.selectedItems[productIndex].forEach(item => {
      if (item) { // Проверяем, что элемент выбран
        totalWeight += Number(item.weight);
        totalProteins += Number(item.nutritionalValue.proteins);
        totalFats += Number(item.nutritionalValue.fats);
        totalCarbo += Number(item.nutritionalValue.carbo);
        totalKkal += Number(item.nutritionalValue.kkal);
      }
    });

    // Обновляем объект с вычисленными значениями для конкретного блюда
    this.selectedItemsValues[productIndex] = {
      weight: Math.round(totalWeight)?.toString(),
      proteins: Math.round(totalProteins)?.toString(),
      fats: Math.round(totalFats)?.toString(),
      carbo: Math.round(totalCarbo)?.toString(),
      kkal: Math.round(totalKkal)?.toString()
    };
  }

  // Функция для плавного раскрытия
  expandSection(element: HTMLElement) {
    const sectionHeight = element.scrollHeight; // Полная высота содержимого
    element.style.height = sectionHeight + 'px';

    // После завершения анимации сбрасываем height обратно на auto
    const transitionEndHandler = () => {
      element.style.height = 'auto';
      element.removeEventListener('transitionend', transitionEndHandler); // Удаляем обработчик
    };

    element.addEventListener('transitionend', transitionEndHandler);
  }

  // Функция для плавного сворачивания
  collapseSection(element: HTMLElement) {
    const sectionHeight = element.scrollHeight;

    // Устанавливаем высоту для начала анимации
    element.style.height = sectionHeight + 'px';

    // Через малый промежуток времени сбрасываем на 0
    requestAnimationFrame(() => {
      element.style.height = '0';
    });
  }

  onImageLoad() {
    // Изображение успешно загрузилось, скрываем лоадер
    this.imageLoaded = true;
  }

  onImagesLoad(index: number) {
    this.isLoaded[index] = true;
  }

  init(element: any) {
    if (this.products.length > 1) {
      this.swiper = element.detail[0];
      const currentId = this.products.findIndex(item => item.id === this.productId);
      setTimeout(() => {
        this.swiper.slideTo(currentId, 0);
        this.isInitSlider = true;
      }, this.appService.isCordova() && this.appService.isIos() ? 800 : 0);
    } else {
      this.isInitSlider = true;
    }
  }

  openComboItemModal(id: number) {
    const product = this.catalogService.productItems.find(obj => obj.id === id);
    if (product) {
      this.modalService.openModal(ProductModalComponent,
        {
          product,
          customBreakpoints: [0, 0.90]}
      );
    } else {
      console.log('Данного продукта нет в каталоге');
    }
  }

  clearedText(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text) as SafeHtml;
  }
}
